"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.object.assign.js");
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const RadioItem = props => {
  const {
    value = null,
    label = '',
    disabled = false,
    labelPlacement = 'end',
    type = '',
    // RadioListItem
    radioType = 'MainRadio' // MainRadio
  } = props;
  const RadioListItem = (0, _styles.styled)(_material.FormControlLabel)(() => ({
    width: '100%',
    margin: 0,
    borderBottom: '1px solid #EAEAEF',
    justifyContent: labelPlacement === 'end' ? '' : 'space-between',
    '&.Mui-disabled': {
      opacity: 0.2
    },
    '.MuiFormControlLabel-label': {
      // color: theme.palette.primary.main,
      width: labelPlacement === 'start' || labelPlacement === 'end' ? '100%' : 100,
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      display: '-webkit-box',
      'WebkitBoxOrient': 'vertical',
      'WebkitLineClamp': '2'
    }
  }));
  const MainRadio = (0, _styles.styled)(_material.Radio)(_ref => {
    let {
      checked
    } = _ref;
    return {
      '& > span:not(.MuiTouchRipple-root):before': {
        content: '""',
        display: 'block',
        position: 'absolute',
        width: '100%',
        height: '100%',
        backgroundColor: checked ? 'transparent' : '#F6F6F9',
        borderRadius: '50%',
        transform: 'scale(.7)',
        transition: 'all .2s'
      },
      '& .MuiSvgIcon-root': {
        width: '1.146em',
        height: '1.146em',
        margin: '-6px',
        fontSize: 28.8,
        transition: 'all .2s',
        color: checked ? '#0000FF' : '#C0C0CF',
        // backgroundColor: checked ? 'transparent' : '#F6F6F9',
        '&:last-child': {
          transform: checked ? 'scale(1.146)' : 'scale(0)'
        }
      }
    };
  });
  const getStyledRadioForm = (0, _react.useCallback)(() => {
    switch (type) {
      case 'RadioListItem':
        return RadioListItem;
      default:
        return _material.FormControlLabel;
    }
  }, [type, RadioListItem]);
  const getStyledRadio = (0, _react.useCallback)(() => {
    switch (radioType) {
      case 'MainRadio':
        return MainRadio;
      default:
        return _material.Radio;
    }
  }, [radioType, MainRadio]);
  const StyledFormControlLabel = p => {
    const radioGroup = (0, _material.useRadioGroup)();
    let checked = false;
    if (radioGroup) checked = radioGroup.value === p.value;
    const StyledFormControlLabel = getStyledRadioForm();
    const StyledRadio = getStyledRadio();
    return /*#__PURE__*/_react.default.createElement(StyledFormControlLabel, _extends({
      checked: checked,
      control: /*#__PURE__*/_react.default.createElement(StyledRadio, null)
    }, p));
  };
  return (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement(StyledFormControlLabel, {
    value: value,
    labelPlacement: labelPlacement,
    label: label,
    disabled: disabled
  }), [value, labelPlacement, label, disabled]);
};
var _default = exports.default = RadioItem;